/* jlc-sv: Verhalten der Selvana-Sections (Seite E). Jede Funktion prüft, ob ihr Element da ist. */
(function(){
  if(window.__jlsv)return;window.__jlsv=true;
  function $(id){return document.getElementById(id)}
  function all(sel){return [].slice.call(document.querySelectorAll(sel))}
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(){
    /* Galerie */
    var track=$('jlsvTrack'),dots=$('jlsvDots'),thumbs=$('jlsvThumbs');
    if(track){
      var slides=track.children;
      [].forEach.call(slides,function(sl,i){
        var d=document.createElement('button');d.type='button';d.setAttribute('aria-label','Bild '+(i+1));if(!i)d.className='on';d.onclick=function(){go(i)};dots&&dots.appendChild(d);
        var t=document.createElement('button');t.type='button';t.setAttribute('aria-label','Bild '+(i+1));if(!i)t.className='on';var ti=document.createElement('img');ti.src=sl.querySelector('img').currentSrc||sl.querySelector('img').src;ti.alt='';ti.loading='lazy';t.appendChild(ti);t.onclick=function(){go(i)};thumbs&&thumbs.appendChild(t);
      });
      var go=function(i){track.scrollTo({left:i*track.clientWidth,behavior:reduce?'auto':'smooth'})};
      track.addEventListener('scroll',function(){var i=Math.round(track.scrollLeft/track.clientWidth);[dots,thumbs].forEach(function(g){g&&[].forEach.call(g.children,function(c,k){c.classList.toggle('on',k===i)})})},{passive:true});
    }

    /* Pakete: Werte stehen als data-* an den Karten */
    var bds=all('.jlsv .bd'),cur=0;
    function swap(el,txt){if(!el||el.textContent===txt)return;if(reduce){el.textContent=txt;return}el.classList.add('swap');el.style.opacity=0;setTimeout(function(){el.textContent=txt;el.classList.remove('swap');el.style.opacity=''},180)}
    function pick(i){
      if(!bds[i])return;cur=i;var d=bds[i].dataset;
      bds.forEach(function(b,k){var on=k===i;b.classList.toggle('on',on);b.setAttribute('aria-checked',on)});
      all('.jlsv .sg').forEach(function(b,k){var on=k===i;b.classList.toggle('on',on);b.setAttribute('aria-checked',on)});
      if(!reduce){var b=bds[i];b.classList.remove('pop');void b.offsetWidth;b.classList.add('pop')}
      swap($('ctaPrice'),d.price);swap($('ctaWas'),d.was);
      swap($('ctaPrice2'),d.name+' · '+d.price);
      var p3=$('ctaPrice3');if(p3)p3.textContent=d.name+' · '+d.price;
      swap($('saveAmt'),d.save);swap($('supply'),d.supply);
    }
    bds.forEach(function(b,i){b.addEventListener('click',function(){pick(i)});if(b.classList.contains('on'))cur=i});
    all('.jlsv .sg').forEach(function(b,i){b.addEventListener('click',function(){pick(i)})});

    function addToCart(btn){
      var b=bds[cur];if(!b)return;var d=b.dataset,o=btn.innerHTML;
      btn.disabled=true;btn.classList.add('busy');
      fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(d.variant),quantity:Number(d.qty)||1}]})})
        .then(function(r){if(!r.ok)throw r;return r.json()})
        .then(function(){location.href=(d.atc==='cart'?'/cart':'/checkout')})
        .catch(function(){btn.innerHTML='Bitte nochmal versuchen';setTimeout(function(){btn.innerHTML=o},1800)})
        .finally(function(){btn.disabled=false;btn.classList.remove('busy')});
    }
    var cta=$('cta'),cta3=$('cta3'),cta2=$('cta2');
    cta&&cta.addEventListener('click',function(){addToCart(this)});
    cta3&&cta3.addEventListener('click',function(){addToCart(this)});
    cta2&&cta2.addEventListener('click',function(){var a=$('angebot')||cta;a&&a.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'})});

    /* Dropdowns weich, immer nur eins offen */
    function animate(body,open){var inner=body.firstElementChild,h=inner.offsetHeight;if(reduce){body.style.height=open?'auto':'0';return}
      var a=body.animate(open?[{height:'0px',opacity:0},{height:h+'px',opacity:1}]:[{height:h+'px',opacity:1},{height:'0px',opacity:0}],{duration:open?320:260,easing:'cubic-bezier(.3,.7,.3,1)'});
      var done=function(){body.style.height=open?'auto':'0'};a.onfinish=done;setTimeout(done,(open?320:260)+60)}
    all('.jlsv .accs').forEach(function(g){g.querySelectorAll('.acc-h').forEach(function(h){h.addEventListener('click',function(){
      var item=h.parentElement,open=!item.classList.contains('open');
      g.querySelectorAll(':scope > .open').forEach(function(o){if(o!==item){o.classList.remove('open');o.querySelector('.acc-h').setAttribute('aria-expanded','false');animate(o.querySelector('.acc-b'),false)}});
      item.classList.toggle('open',open);h.setAttribute('aria-expanded',open);animate(item.querySelector('.acc-b'),open)})})});

    /* Bewertungs-Karussell und Mehr anzeigen */
    var rrow=$('rrow');
    if(rrow){$('rprev')&&($('rprev').onclick=function(){rrow.scrollBy({left:-280,behavior:reduce?'auto':'smooth'})});$('rnext')&&($('rnext').onclick=function(){rrow.scrollBy({left:280,behavior:reduce?'auto':'smooth'})})}
    var more=$('jlsvMore');more&&more.addEventListener('click',function(){all('.jlsv .pc.hide').forEach(function(r){r.classList.remove('hide')});this.remove()});

    /* Einblenden, Zeitstrahl, Sticky (Scroll-Prüfung, nicht nur Observer) */
    var rv=all('.jlsv [data-rv],.jlsv [data-chk],#ctable');
    function check(){var vh=window.innerHeight;
      rv=rv.filter(function(el){if(el.getBoundingClientRect().top<vh*0.9){el.classList.add('in');return false}return true});
      var tl=$('tl'),fill=$('tlFill');
      if(tl&&fill){var r=tl.getBoundingClientRect(),mark=vh*0.7,p=Math.min(1,Math.max(0,(mark-r.top)/r.height));
        fill.style.clipPath='inset(0 0 '+(100-p*100)+'% 0)';
        tl.querySelectorAll('.step').forEach(function(s){s.classList.toggle('hit',s.getBoundingClientRect().top+10<mark)})}
      var st=$('sticky');
      if(st&&cta){var c=cta.getBoundingClientRect(),gc=document.querySelector('.jlsv .gcard'),g=gc?gc.getBoundingClientRect():{top:9e9,bottom:-1};
        var show=c.bottom<0&&!(g.top<vh&&g.bottom>0);st.classList.toggle('show',show);st.setAttribute('aria-hidden',!show)}
    }
    rv.forEach(function(el){if(el.hasAttribute('data-rv')&&el.getBoundingClientRect().top<window.innerHeight)el.classList.add('in')});
    window.addEventListener('scroll',check,{passive:true});window.addEventListener('resize',check);check();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
